import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { scoreColor } from "@/lib/severity";

export function ScoreGauge({ score = 0, grade, size = 200 }) {
  const [display, setDisplay] = useState(0);
  const radius = (size - 24) / 2;
  const circ = 2 * Math.PI * radius;
  const color = scoreColor(score);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 1100;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * score));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [score]);

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#1e293b" strokeWidth="12" fill="none" />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth="12"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circ}
          initial={{ strokeDashoffset: circ }}
          animate={{ strokeDashoffset: circ - (score / 100) * circ }}
          transition={{ duration: 1.1, ease: "easeOut" }}
          style={{ filter: `drop-shadow(0 0 8px ${color}80)` }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-heading font-bold text-white" style={{ fontSize: size * 0.3, color }} data-testid="score-value">
          {display}
        </span>
        <span className="text-slate-500 text-xs uppercase tracking-widest">/ 100</span>
        {grade && (
          <span className="mt-1 font-heading font-bold text-lg" style={{ color }}>
            Grade {grade}
          </span>
        )}
      </div>
    </div>
  );
}
